import css from './Dialog.module.scss';
import EFPicture from 'elem/compCommon/EFPicture';

export default function Dialog({ callback }: any) {
    return (
        <dialog className={`form-dialog ${css['form-dialog']}`}>
            <div className="content">
                <div className="header">
                    <svg className="close" onClick={callback} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L19 18M19 5L6 18" stroke="black" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="body">
                    <p className="title">単相三線式</p>
                    <p className="desc">メインブレーカー</p>
                    <div className="img">
                        <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719311010275/image%201.jpg'} alt={'単相三線式'} />
                    </div>
                    <p className="title">単相二線式</p>
                    <p className="desc">メインブレーカー</p>
                    <div className="img">
                        <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719311036515/image%202.jpg'} alt={'単相三線式'} />
                    </div>
                </div>
            </div>
        </dialog>
    );
}
